/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelJournalCash.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/journal-cash";

export class AutogenModelJournalCash<RowType extends ModelRow> extends Endpoint<RowType, RowJournalCashFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowJournalCash extends ModelRow<RowJournalCashFields> {
	constructor(values?: Partial<RowJournalCashFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowJournalCashFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	batch_code: string;
	batch_number: number;
	batch_seq: number;
	check_no: string;
	company_from: string;
	company_id: string;
	correction: string;
	customer_id: string;
	glid: string;
	gp_exported: Date;
	id: string;
	import_date: Date;
	invoice_no: number;
	invoice_no_string: string;
	is_intercompany: string;
	ltl_id: number;
	memo: string;
	order_id: string;
	post_date: Date;
	post_key: string;
	post_key_bank_trx: string;
	post_module: string;
	transaction_date: Date;
}

